// extracted by mini-css-extract-plugin
export var ad = "style-module--ad--ef47a";
export var ads = "style-module--ads--b1eea";
export var bottomContainer = "style-module--bottomContainer--1477b";
export var content = "style-module--content--da1e6";
export var contentArea = "style-module--contentArea--e6fdf";
export var contentAreaInner = "style-module--contentAreaInner--24f10";
export var description = "style-module--description--719f9";
export var image = "style-module--image--4e5a8";
export var label = "style-module--label--45eb8";
export var loader = "style-module--loader--b0383";
export var relateContainer = "style-module--relateContainer--04448";
export var skeletonAnimation = "style-module--skeleton-animation--91f8b";
export var subContents = "style-module--subContents--f3421";